"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NestedListUtil = void 0;
var NestedListUtil = /** @class */ (function () {
    function NestedListUtil() {
    }
    /* Build a nested list from display values eg "A > B > C" */
    NestedListUtil.build = function (field, data) {
        var builder = field.Mutator.builder;
        data.forEach(function (s) { return NestedListUtil.fromString(builder, s); });
        field.Mutator.init(builder.options);
    };
    NestedListUtil.fromString = function (builder, str) {
        var parts = str.split(' > ');
        var value = builder;
        for (var i = 0; i < parts.length; i++) {
            var part = parts[i];
            var group = value.group;
            if (group == null) {
                group = value.createGroup('Group:' + i);
            }
            var foundValue = group.findValue(part);
            if (foundValue == null) {
                foundValue = group.createValue(part);
            }
            value = foundValue;
        }
    };
    return NestedListUtil;
}());
exports.NestedListUtil = NestedListUtil;
//# sourceMappingURL=nested.list.js.map